enum ImgFolder {
  backgrounds = 'backgrounds',
  cursors = 'cursors',
  projectiles = 'projectiles',
  ships = 'ships',
  weapons = 'weapons',
  hazards = 'hazards',
  animations = 'animations',
}

enum AudioFolder {
  BGMs = 'BGMs',
  effects = 'effects',
}

const baseImg = './img';
const baseAudio = './audio';

export const paths: {
  img: {
    [key in ImgFolder]: string;
  },
  audio: {
    [key in AudioFolder]: string;
  }
} = {
  img: {
    backgrounds: `${baseImg}/backgrounds`,
    cursors: `${baseImg}/cursors`,
    projectiles: `${baseImg}/projectiles`,
    ships: `${baseImg}/ships`,
    weapons: `${baseImg}/weapons`,
    hazards: `${baseImg}/hazards`,
    animations: `${baseImg}/animations`,
  },
  audio: {
    BGMs: `${baseAudio}/BGMs`,
    effects: `${baseAudio}/effects`,
  },
};
